import { Popper, type PopperProps } from '@mui/material';

import { useFullScreen } from '../../FullScreen';

export const CustomPopper = (props: PopperProps) => {
  const { ref } = useFullScreen();

  return <Popper {...props} container={ref.current} />;
};
